import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { image } from '../../../../utils/data/baseUrl';
import { gtmFunctions } from '../../../../constants/analytics/GTM';
import { getSkuFromLink } from '../../../../utils/helpers';

const Selection = React.forwardRef(function Selection(
  { selection: { title = '', list = [] }, title: questTitle },
  ref,
) {
  return (
    !!list?.length && (
      <div className={'selection'}>
        <img src={image('procedureResult/arrow.svg')} className={'selection__arrow'} />
        <div className={'selection__title'}>{safeHTML(title)}</div>
        <div className={`selection__list ${list.length < 2 && 'selection__list_min'}`}>
          {list.map((item, index) => {
            const Tag = item?.link ? 'a' : 'div';
            return (
              <Tag
                className={'selection__item'}
                key={index}
                {...(item?.link && { href: item.link, target: '_blank' })}
                onClick={() => gtmFunctions.GTMToProductAfterQuest(questTitle, getSkuFromLink(item.link))}
              >
                <div className={'selection__item-image'}>
                  <img src={item.image} alt={'selection-image'} />
                </div>
                <div className={'selection__item-name'}>{safeHTML(item.title)}</div>
              </Tag>
            );
          })}
        </div>
      </div>
    )
  );
});
export default Selection;
Selection.propTypes = {};
